import { PaymentType } from './payment-type';
import Decimal from 'decimal.js';
import { SystemUser } from './system-user';
import { Currency } from './currency';
import { Moment } from 'moment';
import { PaymentOrder } from './payment-order';
import { SchoolInvoice } from './school-invoice';

export class PaymentToSupplier {

    constructor(
        public paymentMethod: string | null,
        public date: Moment,
        public amount: Decimal,
        public paymentType: PaymentType,
        public invoiceNumber: string,
        public currency: Currency,
        public paidOrder: PaymentOrder,
        public comment: string | null,
        public paidInvoice: SchoolInvoice | null,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Date,
        public lastModifiedBy?: SystemUser,
        public id?: number,
        public sortOrder?: number,
        public amountInEuro?: Decimal,
        public hidden?: boolean
    ){}
}
